import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
	hasSameDateTime,
	isConsultationTimeTaken,
} from '../../../redux/reducers/consultations';
import { format, addDays, isSameDay } from 'date-fns';
import { TIME_OPTIONS_SELECT } from '../../../constants';
import 'react-datepicker/dist/react-datepicker.min.css';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import ConsultationMovers from './ConsultationMovers';
import {
	setConsultationsTime,
	setConsultationsDate,
	toggleConsultationsEditMode,
	getPotentialMovers,
} from '../../../redux/actions/consultations';
import ReactLoading from 'react-loading';
import { useForceUpdate } from '../../common/Hooks';
import { calcZeroBusinessDays } from '../../../redux/reducers/movePlan';

const mapStateToProps = ({ consultations }) => ({
	options: consultations.options,
	hasSameDateTime: hasSameDateTime(consultations.options),
	isConsultationTimeTaken: isConsultationTimeTaken(consultations),
	loading: consultations.loading,
});

const ConsultationsList = props => {
	let { options, setFieldValue, loading } = props;
	useEffect(() => {
		const hasSelectedMover = options.some(option => !!option.mover);
		setFieldValue('mover_selected', hasSelectedMover);
	}, [options, setFieldValue]);
	const forceUpdate = useForceUpdate();

	const handleToggle = index => {
		if (!options[index].scheduled) {
			props.toggleConsultationsEditMode(index);
		}
	};

	const handleDateChange = (date, index) => {
		props.setConsultationsDate(index, date);
		forceUpdate();
	};

	const selectTime = (option, index) => {
		props.setConsultationsTime(index, option.value);
	};

	const handleFindMovers = index => {
		props.setFieldError('mover_selected', false);
		props.getPotentialMovers(index);
	};
	return (
		!!options &&
		!!loading && (
			<div className="meeting-list mt-4">
				<ul className="container">
					{options.map((option, index) => (
						<li
							key={JSON.stringify(options + index)}
							className={`meeting  ${option.editMode && 'active'}`}>
							<div className="toggle" onClick={() => handleToggle(index)}>
								<svg className="icon icon-orange-arrow">
									<use xlinkHref="#icon-orange-arrow" />
								</svg>
							</div>

							{!option.editMode && option.mover === undefined && (
								<div className="meeting-edit">
									<span className="meeting-num">
										{index + 1}. Date & Time {index > 0 ? '(optional)' : ''}
									</span>
								</div>
							)}

							{!option.editMode && option.mover !== undefined && (
								<div className="row">
									<div className="scheduled-time-date col-sm-4">
										<div className="scheduled-date">
											{index + 1}. Date:{' '}
											<strong>{format(option.date, 'MM/DD/YYYY')}</strong>
										</div>
										<div className="scheduled-time">
											Time: <strong>{option.time}</strong>
										</div>
									</div>
									<div className="scheduled-mover col-sm-3">
										<div className="logo-wrapper">
											<img
												src={option.mover.logo_url}
												style={{ maxHeight: '50px' }}
												height="50"
												alt="mover logo"
											/>
										</div>
									</div>
									<div className="col-sm-3">
										<span className="mover-name">{option.mover.name}</span>
									</div>
								</div>
							)}

							{option.editMode && (
								<div className="meeting-edit">
									<span className="meeting-num">
										{index + 1}. Date & Time {index > 0 ? '(optional)' : ''}
									</span>

									<div className="meeting-controls row animate-show mt-2 ml-1">
										<div className="control datepicker-wrapper pika-static-parent consult-datetime mr-3">
											<span className="icon datepicker datepicker-icon">
												<svg className="icon icon-calendar">
													<use xlinkHref="#icon-calendar" />
												</svg>{' '}
												&nbsp;
											</span>
											<DatePicker
												className="consultation-date p-0 pl-3 m-auto"
												selected={new Date(options[index].date)}
												onChange={date => handleDateChange(date, index)}
												minDate={calcZeroBusinessDays()}
												maxDate={addDays(Date.now(), 7)}
											/>
										</div>

										<div className="consult-datetime mr-3">
											<Select
												isSearchable={false}
												className={`control time-select ${
													(props.hasSameDateTime ||
														props.isConsultationTimeTaken) &&
													props.noMoverError
												}`}
												options={TIME_OPTIONS_SELECT}
												isOptionDisabled={selectOption =>
													(isSameDay(
														options[index].date,
														options[(index + 1) % 3].date
													) &&
														selectOption.value ===
															options[(index + 1) % 3].time) ||
													(isSameDay(
														options[index].date,
														options[(index + 2) % 3].date
													) &&
														selectOption.value ===
															options[(index + 2) % 3].time)
												}
												styles={customStyles}
												onChange={selectedOption =>
													selectTime(selectedOption, index)
												}
												defaultValue={TIME_OPTIONS_SELECT[index]}
											/>
										</div>
										<div className="consult-datetime">
											<button
												aria-label="Find Movers"
												type="button"
												style={{
													minWidth: '100px',
													padding: '8px 10px 8px 10px',
												}}
												className="control cta-button filled small find"
												onClick={() => handleFindMovers(index)}
												disabled={
													!(options[index].time && options[index].date) ||
													props.isConsultationTimeTaken
												}>
												{props.loading[index] ? (
													<ReactLoading
														className="m-auto"
														type={'spokes'}
														color={'#ffffff'}
														height={14}
														width={14}
													/>
												) : (
													<>Find Movers</>
												)}
											</button>
										</div>
										{props.hasSameDateTime[index].some(
											elem => elem === true
										) && (
											<span className="field-error-message message">
												Only one consultation can be scheduled within a
												particular time.
											</span>
										)}
										{props.noMoverError && (
											<span className="field-error-message message">
												Select at least one moving company to submit your
												request.
											</span>
										)}
										{options[index].noMoversFound && (
											<span className="field-error-message message">
												We couldn't find any movers that match your criteria.
											</span>
										)}
										{options[index].movers.length > 0 &&
											option.date &&
											option.time && (
												<ConsultationMovers
													index={index}
													options={options}
													setFieldValue={props.setFieldValue}
												/>
											)}
									</div>
								</div>
							)}
							<hr />
						</li>
					))}
				</ul>
				<style jsx>{`
					.toggle {
						display: block;
						position: absolute;
						right: 0;
						top: 0;

						background-size: cover;
						-webkit-transition: all 0.2s ease-in-out;
						-o-transition: all 0.2s ease-in-out;
						transition: all 0.2s ease-in-out;
						cursor: pointer;
					}
					.meeting {
						position: relative;
					}
					.active.meeting > .toggle {
						transform: rotate(180deg);
					}
					.scheduled-time {
						margin-left: 0.8rem;
					}
					.scheduled-time,
					.scheduled-date > strong {
						font-size: 0.9rem;
					}
					.consult-datetime {
						width: 30%;
						display: flex;
						align-items: flex-start;
						margin-right: 1%;
						position: relative;
					}
					.consult-datetime .cta-button {
						font-size: 11px;
					}
					.datepicker-icon {
						position: absolute;
						right: 5px;
						z-index: 1;
						top: 5px;
					}
				`}</style>
			</div>
		)
	);
};

const customStyles = {
	option: (initial, state) => ({
		...initial,
		color: state.isDisabled ? '#ebebeb' : '#042B3B',
		display: 'flex',
		alignItems: 'center',
		position: 'relative',
		zIndex: 10,
		border: '1px solid #829ca1',
		borderTop: 0,
		backgroundColor: state.isFocused || state.isSelected ? '#e2e3e5;' : 'white',
		borderLeft:
			state.isFocused || state.isSelected ? '3px solid #F78022' : 'auto',
		paddingLeft: state.isFocused || state.isSelected ? 10 : 'auto',
	}),
	container: (initial, state) => ({
		...initial,
		border:
			state.isFocused || state.isSelected
				? '1px solid #022b3c'
				: '1px solid #829ca1',
		width: '100%',
		height: '100%',
		fontSize: 13,
		background: '#f5f5f5',
		borderRadius: '3px',
		cursor: 'pointer',
	}),
	control: () => ({
		display: 'flex',
		color: '#f7801e',
		padding: '5px 5px',
	}),
	dropdownIndicator: () => ({}),
	menu: () => ({
		height: 0,
	}),
	menuList: () => ({
		paddingTop: 1,
	}),
};

export default connect(mapStateToProps, {
	toggleConsultationsEditMode,
	setConsultationsDate,
	setConsultationsTime,
	getPotentialMovers,
})(ConsultationsList);
